module.exports = __webpack_public_path__ + "img/illusion-en.dfd6ce4.svg";